const mode = {
  view: 1,
  bundle: 2,
}

const displayMode = {
  mobile: 1,
  desktop: 2,
}

const modalMode = {
  default: 1,
  error: 2,
  success: 3,
}

export default {
  mode,
  displayMode,
  modalMode,
}
